import React, { Fragment, useState, useRef, useEffect, useContext } from "react";

import { AppContext } from "../../../../components/AppProvider";
import { _API, _CK, _U } from "../../../../modules/utils";
import swal from "sweetalert";
import moment from "moment";
import styled from "styled-components";
import cx from "classnames";
import TextareaAutosize from "react-textarea-autosize";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import replyImg from "../../../../resources/console/images/icon/icon-s-reply.svg";
import replystImg from "../../../../resources/console/images/icon/st-reply.svg";
import replycountImg from "../../../../resources/console/images/icon/icon-s-replycount.svg";
import replycountOnImg from "../../../../resources/console/images/icon/icon-s-replycount-on.svg";
import replydelImg from "../../../../resources/console/images/icon/icon-s-delete-2.svg";
import { isEmpty } from "lodash";

export default (props) => {
  const { iam } = useContext(AppContext);
  const { consoleCfg } = props;
  const [isSendProc, setIsSendProc] = useState(false);
  const [questionList, setQuestionList] = useState([]);
  const [questionReplyContent, setQuestionReplyContent] = useState({});
  const [questionContent, setQuestionContent] = useState("");
  const [moreView, setMoreView] = useState({ nextPage: 0, pagePerCount: 20 });
  const [totalCount, setTotalCount] = useState(0);
  const [remainListCount, setRemainListCount] = useState(0);
  const [myQuestion, setMyQuestion] = useState({ onOff: "N" });
  const [toggleMenu, setToggleMenu] = useState({});
  const [forceUpdate, setForceUpdate] = useState(0); // 🔧 강제 리렌더링용
  const isInitialLoadDone = useRef(false);
 
  const onSetQuestionContent = (e) => {
    if (e.target.value.length <= 500) {
      setQuestionContent(e.target.value);
    }
  };

  const myQuestionView = (e, value) => {
    if (e) e.preventDefault();

    // 이미 선택된 탭이면 무시
    if (myQuestion.onOff === value) {
      return;
    }

    // 상태 업데이트만 (렌더링 조건에서 알아서 필터링)
    setMyQuestion({ onOff: value });
    
    // 🔧 카운트 재계산 (필터링된 질문 수)
    const visibleCount = questionList.filter((q) => {
      // "내질문보기"인 경우
      if (value === "Y") {
        return q.regId === (iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx);
      }
      // "전체질문보기"인 경우
      if (iam.memAuth === "ADMIN") {
        return true; // 관리자는 모든 질문
      }
      // 참가자: 본인 질문 또는 노출된 질문
      const isMyQuestion = q.regId === iam.preregIdx;
      const isPublicQuestion = q.showYn === 'Y';
      return isMyQuestion || isPublicQuestion;
    }).length;
    
    setTotalCount(visibleCount);
  };

  const onSetNextPage = (e) => {
    let num = 0;
    if(document.body.clientWidth+15 < 568){
      num = $(".m_qna_container .question_list_inner_box").length;
    }else{
      num = $(".pc_qna_container .question_list_inner_box").length;
    }
    setMoreView((o) => {
      return { ...o, ["nextPage"]: num };
    });
  };

  const loadQuestionList = (item) => {
    let nextPage = 0;
    let pagePerCount = 0;

    if(item){
      nextPage = item.nextPage;
      pagePerCount = item.pagePerCount;
    } else {
      nextPage = moreView.nextPage;
      pagePerCount = moreView?.pagePerCount;
    }

    const req = {
      path: "/v1/client/question/list",
      data: {
        eventIdx: consoleCfg.eventIdx,
        sessionIdx: consoleCfg.sessionIdx,
        myQuestion: myQuestion.onOff,
        pagePerCount: pagePerCount,
        nextPage: nextPage,
      },
    };

    _API.post(req).then((res) => {
      let { data, totalCount, remainListCount } = res.data;
      setRemainListCount(remainListCount);

      const computeVisibleCount = (list) =>
        list.filter((q) => {
          if (iam.memAuth === "ADMIN") {
            return true; // 관리자는 모든 질문
          }
          // 참가자: 본인 질문 또는 공개된 질문
          const isMyQuestion = q.regId === iam.preregIdx;
          const isPublicQuestion = q.showYn === 'Y';
          return isMyQuestion || isPublicQuestion;
        }).length;

      if (data.length > 0) {
        if(item && item.gubun == "INSERT"){
          // 🔧 덮어쓰지 않고 기존 리스트와 merge (race 상황에서 기존 항목 유지)
          setQuestionList((o) => {
            const seen = new Set();
            const merged = [];
            for (const q of data) {
              if (q && q.idx != null && !seen.has(q.idx)) {
                seen.add(q.idx);
                merged.push(q);
              }
            }
            for (const q of o) {
              if (q && q.idx != null && !seen.has(q.idx)) {
                seen.add(q.idx);
                merged.push(q);
              }
            }
            setTotalCount(computeVisibleCount(merged));
            return merged;
          });
        }else{
          setQuestionList((o) => {
            // 🔧 idx 기반 dedup merge (race 상황에서 중복 삽입 방지)
            const seen = new Set();
            const nb = [];
            for (const q of o) {
              if (q && q.idx != null && !seen.has(q.idx)) {
                seen.add(q.idx);
                nb.push(q);
              }
            }
            for (const q of data) {
              if (q && q.idx != null && !seen.has(q.idx)) {
                seen.add(q.idx);
                nb.push(q);
              }
            }
            setTotalCount(computeVisibleCount(nb));
            return nb;
          });
        }
      } else if (item && item.gubun == "INSERT") {
        setQuestionList([]);
        setTotalCount(0);
      }

      if(moreView?.pagePerCount == 10){
        setMoreView((o) => {
          return {...o, ['pagePerCount'] : 5}
        })
      }
    });
  };

  const questionSave = () => {

    // 🔍 사용자 타입에 따른 올바른 ID 사용
    // 관리자: T_MEMBER.IDX (iam.idx 필드)  
    // 일반사용자: T_PREREG_INFO.IDX (iam.preregIdx 필드)
    const correctRegId = iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx;

    let item = {division : 'QUESTION', detail : 'INSERT', 
                cName : iam.name, content : questionContent, questionerType: iam.memAuth === "ADMIN" ? "MANAGER" : "ATTENDER",
                questionStatus : iam.memAuth == "ADMIN" ? "REQUEST" : "WAIT",
                answerYn : iam.memAuth == "ADMIN" ? 'Y' : "N",
                regId : correctRegId
              }

    if(!questionContent || questionContent.trim() === "") {
      alert('Please enter your question.');
      return false;
    }

    onSend(item);

    setQuestionContent("");
  };

  const questionSetShow = (param) => {

      const correctRegId = iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx;
      
      let item;
      
      // 🚀 사전질문인 경우: 회수(REMOVE) 처리 (preQuestionCollection 방식)
      if (param.questionGubun === 'PRE' && param.preIdx) {
        item = {
          direction: "live", 
          division: "QUESTION", 
          detail: "REMOVE", 
          idx: param.idx,  // 라이브로 이동된 질문 ID (submittedIdx 역할)
          questionStatus: param.questionStatus, 
          preIdx: param.preIdx  // 원본 사전질문 ID
        };
      } else {
        // 일반 질문인 경우: ONOFF 처리
        item = {
          direction: param.questionStatus == 'WAIT' ? 'live' : 'review',
          idx: param.idx, 
          division: "QUESTION", 
          detail: "ONOFF", 
          regId: correctRegId, 
          questionStatus: param.questionStatus == "REQUEST" ? "WAIT" : "REQUEST"
        };
      }

      onSend(item);
    
  };
  
  const removeQna = (tableName, val) => {

    var confirmChkTxt = tableName == "T_QUESTION" ? "Are you sure you want to delete this question?" : "Are you sure you want to delete this comment?";

    if (window.confirm(confirmChkTxt)) {

      let item = {division : tableName == "T_QUESTION" ? "QUESTION" : "COMMENT" , 
                  direction : 'live', detail : "REMOVE", idx : val.idx, 
                  preIdx : val.preIdx, tQuestionIdx : val.tQuestionIdx};

      onSend(item);

      if (!val.idx) {
        $(".qna.scroll-wrap")[0].scrollTop = 0;
      }

    }

  };

  const questionCommentSetShow = (data) => {

    const correctModId = iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx;

    const item = {};

    item.eventIdx = consoleCfg.eventIdx;
    item.sessionIdx = consoleCfg.sessionIdx;
    item.consoleIdx = consoleCfg.consoleIdx;
    item.idx = data.idx;
    item.tQuestionIdx = data.tQuestionIdx;
    item.content = data.contents;
    item.regId = data.regId;  // 🔧 원본 작성자 ID 유지
    item.modId = correctModId;  // 🔧 수정자 ID 별도 관리
    item.showYn = data.showYn == 'Y' ? 'N' : 'Y' 
    item.detail = "UPDATE";
    item.division = 'COMMENT';
    item.regDate = data.regDate;  // 🔧 원본 작성일 유지
    item.modDate = new Date();  // 🔧 수정일 별도 관리
    item.writeLocation = "CONSOLE";

    setQuestionContent("");
    if (item.answerYn === "Y") {
        changeReplyContent(item, "");
    }

    onSend(item);

    if (!data.idx) {
        $(".qna.scroll-wrap")[0].scrollTop = 0;
    }

  };

  const commentSave = (data) => {

    const correctRegId = iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx;

    const item = {};

    item.eventIdx = consoleCfg.eventIdx;
    item.sessionIdx = consoleCfg.sessionIdx;
    item.consoleIdx = consoleCfg.consoleIdx;
    item.questionIdx = data.idx;
    item.content = questionReplyContent[`answerContent-${data.idx}`];
    item.regId = correctRegId;
    item.showYn = iam?.memAuth == 'ADMIN' ? 'Y' : "N";
    item.detail = "INSERT";
    item.division = 'COMMENT';
    item.regDate = new Date();
    item.writeLocation = "CONSOLE";

    // 댓글 내용 초기화 (올바른 방식)
    setQuestionReplyContent((prev) => ({
      ...prev,
      [`answerContent-${data.idx}`]: ""
    }));

    // 댓글 작성 박스 숨기기
    setShowCommentWriteBox(data, false);

    onSend(item);

    if (!data.idx) {
        $(".qna.scroll-wrap")[0].scrollTop = 0;
    }

  };

  const changeReplyContent = (item, value) => {
    const key = `answerContent-${item.idx}`;
    if (value.length <= 300) {
      setQuestionReplyContent((o) => {
        return { ...o, [key]: value };
      });
    }
  };

  const questionReply = (item) => {

    if (!questionReplyContent[`answerContent-${item.idx}`]) {
      swal("Please enter your answer.");
      return;
    }

    commentSave(item);

    // commentSave 함수에서 이미 댓글 내용을 초기화하므로 여기서는 제거

  };

  const setCommentListShowYn = (i) => {
    setQuestionList((o) => {
      const nb = [...o];
      nb[i].commentListShowYn = nb[i]?.commentListShowYn === "Y" ? "N" : "Y";
      return nb;
    });
  };

  const onSend = (item) => {
    // 질문 등록 시에만 내용 확인
    if (item.detail === 'INSERT' && item.division === 'QUESTION') {
      if (!questionContent || questionContent.trim() === "") {
        return;
      }
    }

    // 댓글 등록 시에만 댓글 내용 확인
    if (item.detail === 'INSERT' && item.division === 'COMMENT') {
      if (!item.content || item.content.trim() === "") {
        return;
      }
    }

    if (isSendProc) {
      return;
    }

    setIsSendProc(true);
    _U.postMessage("SOCKET-SEND", {
      action: "FMS",
      data: {
        mode: "FMS",
        siteIdx: consoleCfg?.siteIdx,
        eventIdx: consoleCfg?.eventIdx,
        sessionIdx: consoleCfg?.sessionIdx,
        consoleIdx: consoleCfg?.consoleIdx,
        name: iam?.name,
        memType: iam?.memType,
        companyName: iam?.companyName,
        deptName: iam?.deptName,
        memberIdx: iam?.idx,
        item: item,
      },
    });
    setIsSendProc(false);
  };

  const showTogleReplyWrap = (item) => {
    if (item.idx) $("#reply-wrap-group-" + item.idx).slideToggle();
  };

  
  const onReceivedMessage = (e) => {
    const y = $(window).scrollTop();
    _U.parseMessage(e).then((data) => {
        switch (data.code) {
          case "SOCKET-RECEIVED":
            return data.data ? JSON.parse(data.data) : null;
        }
      }).then((data) => {
        if(!data){
          data = data?.data
        }

        // WebSocket 데이터 추출 (공통)
        const originalData = data;
        const updatedQuestion = originalData?.updatedQuestion;
        const updatedQuestions = originalData?.updatedQuestions;
        const liveList = originalData?.updatedQuestions?.liveList;
        const reviewList = originalData?.updatedQuestions?.reviewList;
        const stats = originalData?.stats;

        if (data?.mode == "FMS" && data?.eventIdx == consoleCfg.eventIdx && data?.sessionIdx == consoleCfg.sessionIdx) {
          if(data?.item.division == "QUESTION"){
            if(data?.item.detail == "INSERT"){

              // 서버에서 전송한 업데이트된 질문 목록 데이터로 상태 업데이트 (최적화)
              if (updatedQuestions && (updatedQuestions.reviewList || updatedQuestions.consoleList)) {
                // Hub FMS에서 보낸 데이터 구조 처리
                const consoleData = updatedQuestions.consoleList || updatedQuestions.reviewList || updatedQuestions;
                if (consoleData && consoleData.length > 0) {
                  // 🚀 새 질문을 기존 목록에 추가 (덮어쓰기 방지)
                  const newQuestion = consoleData[0]; // 새로 추가된 질문 1개
                  setQuestionList((prevList) => {
                    // 중복 체크
                    const exists = prevList.some(q => q.idx === newQuestion.idx);
                    if (!exists) {
                      const newList = [newQuestion, ...prevList];
                      
                      // 🔧 클라이언트 필터링으로 카운트 재계산
                      const visibleCount = newList.filter((q) => {
                        if (iam.memAuth === "ADMIN") {
                          return true; // 관리자는 모든 질문
                        }
                        // 참가자: 본인 질문 또는 공개된 질문
                        const isMyQuestion = q.regId === iam.preregIdx;
                        const isPublicQuestion = q.showYn === 'Y';
                        return isMyQuestion || isPublicQuestion;
                      }).length;
                      setTotalCount(visibleCount);
                      
                      return newList;
                    }
                    return prevList;
                  });
                } else {
                  // Fallback: API 호출 (서버 데이터가 비어있는 경우에만)
                  let item = {
                    nextPage : 0,
                    pagePerCount : 10,
                    gubun : "INSERT",
                  }
                  loadQuestionList(item);
                }
              } else if (updatedQuestion) {
                // 단일 질문 추가 최적화 - 새 질문을 목록 맨 앞에 추가
                setQuestionList((prevList) => {
                  // 중복 체크
                  const exists = prevList.some(q => q.idx === updatedQuestion.idx);
                  if (!exists) {
                    const newList = [updatedQuestion, ...prevList];
                    
                    // 🔧 클라이언트 필터링으로 카운트 재계산
                    const visibleCount = newList.filter((q) => {
                      if (iam.memAuth === "ADMIN") {
                        return true; // 관리자는 모든 질문
                      }
                      // 참가자: 본인 질문 또는 공개된 질문
                      const isMyQuestion = q.regId === iam.preregIdx;
                      const isPublicQuestion = q.showYn === 'Y';
                      return isMyQuestion || isPublicQuestion;
                    }).length;
                    setTotalCount(visibleCount);
                    
                    return newList;
                  }
                  return prevList;
                });
              } else {
                // Fallback: API 호출 (서버 데이터가 없는 경우에만)
                let item = {
                  nextPage : 0,
                  pagePerCount : 10,
                  gubun : "INSERT",
                }
                loadQuestionList(item);
              }

            } else if(data?.item.detail === "MOD"){
              
              // 사전질문이 라이브로 이동한 경우 (PreList → Live) - 최적화
              if(data?.item.preIdx && data?.item.isMove) {
                
                // 서버에서 전송한 업데이트된 질문 목록 데이터로 상태 업데이트
                const consoleData = updatedQuestions?.consoleList || updatedQuestions;
                if (consoleData && consoleData.length > 0) {
                  // 🚀 사전질문 라이브 이동 시 기존 리스트에 추가 (덮어쓰기 방지)
                  const movedQuestion = consoleData[0]; // 이동된 질문 1개
                  
                  setQuestionList((prevList) => {
                    // 중복 체크
                    const exists = prevList.some(q => q.idx === movedQuestion.idx);
                    if (!exists) {
                      return [movedQuestion, ...prevList]; // 맨 앞에 추가
                    }
                    return prevList;
                  });
                  
                  // 통계 업데이트 (새 질문 추가)
                  if (stats) {
                    setTotalCount(stats.total); // 서버에서 계산된 전체 카운트 사용
                  } else {
                    // Fallback: 기존 카운트 + 1 (새 질문 1개 추가)
                    setTotalCount(prev => prev + 1);
                  }
                } else {
                  let item = {
                    nextPage : 0,
                    pagePerCount : 10,
                    gubun : "INSERT",
                  }
                  loadQuestionList(item);
                }
              } else {
                // 일반 질문 MOD 처리 - 개별 업데이트 (최적화)
                if (updatedQuestion) {
                  setQuestionList((o) => {
                    let nb = [...o];
                    for (let i in nb) {
                      if (nb[i].idx == updatedQuestion.idx) {
                        // 댓글 목록 보존하면서 업데이트
                        nb[i] = { ...nb[i], ...updatedQuestion, commentList: nb[i].commentList };
                      }
                    }
                    return nb;
                  });
                }
              }

            } else if(data?.item.detail == "ONOFF"){

              if(data.item.direction == "archiveToReview" || data.item.direction == "archive") {

                // 아카이브 관련 액션은 전체 목록 새로고침 필요 (최적화)
                if (updatedQuestions && updatedQuestions.length > 0) {
                  setQuestionList(updatedQuestions);
                  
                  // 통계 업데이트
                  if (stats) {
                    setTotalCount(stats.total || updatedQuestions.length);
                  }
                } else {
                  // Fallback: API 호출
                  let item = {
                    nextPage : 0,
                    pagePerCount : 10,
                    gubun : "INSERT",
                  }
                  loadQuestionList(item);
                }

              } else {
                
                // Live/Review 상태 변경은 개별 업데이트 (최적화)
                if (updatedQuestion) {
                  setQuestionList((o) => {
                    let nb = [...o];
                    let found = false;
                    
                    // 기존 질문 중에서 해당 질문 찾아서 업데이트
                    for (let i in nb) {
                      if (nb[i].idx == updatedQuestion.idx) {
                        // 댓글 목록 보존하면서 업데이트
                        nb[i] = { ...nb[i], ...updatedQuestion, commentList: nb[i].commentList };
                        found = true;
                        break;
                      }
                    }
                    
                    // 🚀 사전질문이 라이브로 이동한 경우: 기존 리스트에 없으면 추가
                    if (!found && data.item.direction === 'live') {
                      nb = [updatedQuestion, ...nb]; // 맨 앞에 추가
                    }
                    
                    // 🔧 클라이언트 필터링으로 카운트 재계산
                    const visibleCount = nb.filter((q) => {
                      if (iam.memAuth === "ADMIN") {
                        return true; // 관리자는 모든 질문
                      }
                      // 참가자: 본인 질문 또는 공개된 질문
                      const isMyQuestion = q.regId === iam.preregIdx;
                      const isPublicQuestion = q.showYn === 'Y';
                      return isMyQuestion || isPublicQuestion;
                    }).length;
                    setTotalCount(visibleCount);
                    
                    return nb;
                  });
                } else {
                  // Fallback: 기존 로직 (서버에서 updatedQuestion을 보내지 않는 경우)
                  
                  // 🚨 사전질문 라이브 이동 시 updatedQuestion이 없는 경우 전체 리스트 재로드
                  if (data.item.direction === 'live') {
                    let item = {
                      nextPage: 0,
                      pagePerCount: 10,
                      gubun: "INSERT",
                    };
                    loadQuestionList(item);
                    return; // 여기서 종료
                  }
                  
                  setQuestionList((o) => {
                    let nb = [...o];
                    if(nb?.filter((q) => q.idx == data?.item.idx)?.length > 0){
                      for (let i in nb) {
                        if (nb[i].idx == data?.item.idx) {
                          nb[i].questionStatus = data?.item.questionStatus;
                        }
                      }
                    }
                    
                    // 🔧 클라이언트 필터링으로 카운트 재계산
                    const visibleCount = nb.filter((q) => {
                      if (iam.memAuth === "ADMIN") {
                        return true; // 관리자는 모든 질문
                      }
                      // 참가자: 본인 질문 또는 공개된 질문
                      const isMyQuestion = q.regId === iam.preregIdx;
                      const isPublicQuestion = q.showYn === 'Y';
                      return isMyQuestion || isPublicQuestion;
                    }).length;
                    setTotalCount(visibleCount);
                    
                    return nb;
                  });
                }
              }
            } else if(data?.item.detail == "REMOVE"){
              
              // 질문 목록에서 제거 후 카운트 재계산
              setQuestionList((prevList) => {
                const newList = prevList.filter(question => question.idx !== data?.item?.idx);
                
                // 🔧 클라이언트 필터링으로 카운트 재계산
                const visibleCount = newList.filter((q) => {
                  if (iam.memAuth === "ADMIN") {
                    return true; // 관리자는 모든 질문
                  }
                  // 참가자: 본인 질문 또는 공개된 질문
                  const isMyQuestion = q.regId === iam.preregIdx;
                  const isPublicQuestion = q.showYn === 'Y';
                  return isMyQuestion || isPublicQuestion;
                }).length;
                setTotalCount(visibleCount);
                
                return newList;
              });
            }  
          } else if(data?.item.division == "COMMENT") {
            if(data?.item.detail == 'INSERT') {

              // 서버에서 전송한 댓글 데이터와 업데이트된 질문 데이터로 상태 업데이트 (최적화)
              const commentData = originalData?.commentData;
              
              if (commentData && updatedQuestion) {
                setQuestionList((o) => {
                  // 🔧 불변성을 유지하면서 업데이트
                  const nb = o.map((question) => {
                    if (question.idx == updatedQuestion.idx) {
                      // 기존 댓글 목록 가져오기
                      const existingComments = question.commentList || [];
                      
                      // 중복 체크
                      const exists = existingComments.some(c => c.idx === commentData.idx);
                      
                      let newCommentList;
                      if (!exists) {
                        // 🔧 name 필드 추가 (commentData에 없을 경우를 대비)
                        const commentWithName = {
                          ...commentData,
                          name: commentData.name || data.name || null
                        };
                        // 🔧 새 배열 생성 (불변성 유지)
                        newCommentList = [...existingComments, commentWithName];
                      } else {
                        newCommentList = existingComments;
                      }
                      
                      // 🔧 새 객체 반환 (불변성 유지)
                      return {
                        ...question,
                        ...updatedQuestion,
                        commentList: newCommentList,
                        commentListShowYn: "Y",
                        showCommentWriteBox: false
                      };
                    }
                    return question;
                  });
                  
                  return nb;
                });
              } else {
                // Fallback: 기존 로직
                setQuestionList((o) => {
                  // 🔧 불변성을 유지하면서 업데이트
                  const nb = o.map((question) => {
                    if (question.idx == data?.item?.questionIdx) {
                      
                      let cData =  {
                        idx : data.insertGetId,
                        tQuestionIdx: data.item.questionIdx,
                        contents: data.item.content,
                        regId: data.item.regId,
                        regDate: data.item.regDate,
                        modId: data.item.regId,
                        modDate: data.item.regDate,
                        showYn: data.item.showYn,
                        name: data.name
                      }

                      // 기존 댓글 목록 가져오기
                      const existingComments = question.commentList || [];
                      
                      // 중복 체크
                      const exists = existingComments.some(c => c.idx === cData.idx);
                      
                      let newCommentList;
                      if (!exists) {
                        // 🔧 새 배열 생성 (불변성 유지)
                        newCommentList = [...existingComments, cData];
                      } else {
                        newCommentList = existingComments;
                      }

                      // 🔧 새 객체 반환 (불변성 유지)
                      return {
                        ...question,
                        commentList: newCommentList,
                        commentListShowYn: "Y",
                        showCommentWriteBox: false
                      };
                    }
                    return question;
                  });
                  
                  return nb;
                });
              }
              
              // 🔧 강제 리렌더링 트리거
              setForceUpdate(prev => prev + 1);
            } else if(data?.item.detail == 'REMOVE') {

              // 서버에서 전송한 업데이트된 질문 데이터로 상태 업데이트 (최적화)
              if (updatedQuestion) {
                setQuestionList((o) => {
                  const nb = [...o];
                  for (let i in nb) {
                    if (nb[i].idx == updatedQuestion.idx) {
                      // 질문 정보 업데이트 (commentCnt 포함)
                      nb[i] = { ...nb[i], ...updatedQuestion };
                      
                      // 댓글 목록에서 삭제된 댓글 제거
                      if (nb[i]?.commentList) {
                        nb[i].commentList = nb[i].commentList.filter(
                          comment => comment.idx !== data?.item?.idx
                        );
                      }
                    }
                  }
                  return nb;
                });
              } else {
                // Fallback: 기존 로직
                setQuestionList((o) => {
                  const nb = [...o];
                  for (let i in nb) {
                    if (nb[i].idx == data?.item?.tQuestionIdx) {
                      // 댓글 목록에서 삭제된 댓글 제거 (최적화)
                      if (nb[i]?.commentList) {
                        nb[i].commentList = nb[i].commentList.filter(
                          comment => comment.idx !== data?.item?.idx
                        );
                      }
                    }
                  }
                  return nb;
                });
              }

            } else if(data?.item.detail == 'UPDATE') {

              // 서버에서 updatedQuestion을 보내지 않으므로 기존 로직 유지하되 최적화
              setQuestionList((o) => {
                const nb = [...o];

                for (let i in nb) {
                  if (nb[i].idx == data?.item?.tQuestionIdx) {
                    // 댓글 목록에서 해당 댓글 업데이트 (최적화)
                    if (nb[i]?.commentList) {
                      nb[i].commentList = nb[i].commentList.map(comment => {
                        if (comment.idx === data?.item?.idx) {
                          return {
                            ...comment,
                            idx: data.item.idx,
                            tQuestionIdx: data.item.tQuestionIdx,
                            contents: data.item.content,
                            regId: data.item.regId,
                            regDate: data.item.regDate,
                            modId: data.item.regId,
                            modDate: data.item.regDate,
                            showYn: data.item.showYn,
                            name: data.name
                          };
                        }
                        return comment;
                      });
                    }
                  }
                }
                return nb;
              });

            }

          }
        }
        // 레거시 saveGubun 로직은 새로운 WebSocket 최적화로 대체됨
        // 기존 로직 제거하여 중복 처리 방지
        
        /* 레거시 로직 주석처리
        if (data?.item?.saveGubun === "INSERT") {
          if (data?.item?.division === "QUESTION") {
            if (
              data?.item?.showYn === "Y" ||
              iam.memAuth == "ADMIN" ||
              data?.item?.regId == (iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx)
            ) {
              setTotalCount((o) => {
                return ++o;
              });
            }
            const tmp = [];
            tmp.push(data.item);
            setQuestionList((o) => {
              const nb = [...o];
              for (let i in nb) {
                tmp.push(nb[i]);
              }
              return tmp;
            });
          } else if (data?.item?.division === "COMMENT") {

            // 서버에서 전송한 댓글 데이터와 업데이트된 질문 데이터로 상태 업데이트
            const commentData = originalData?.commentData;
            
            if (commentData && updatedQuestion) {
              setQuestionList((o) => {
                const nb = [...o];
                for (let i in nb) {
                  if (nb[i].idx == updatedQuestion.idx) {
                    // 질문 정보 업데이트 (commentCnt 포함)
                    nb[i] = { ...nb[i], ...updatedQuestion };
                    
                    // 댓글 목록에 새 댓글 추가
                    if (nb[i]?.commentList) {
                      nb[i].commentList.push(commentData);
                    } else {
                      nb[i].commentList = [commentData];
                    }
                    
                    nb[i].showCommentWriteBox = false;
                  }
                }
                return nb;
              });
            } else {
              // Fallback: 기존 로직
              setQuestionList((o) => {
                const nb = [...o];
                for (let i in nb) {
                  if (nb[i].idx == data?.item?.tQuestionIdx) {
                    if (nb[i]?.commentList) {
                      let length = nb[i]?.commentList
                        ? nb[i]?.commentList?.length
                        : 0;
                      nb[i].commentList[length] = data?.item;
                    } else {
                      let array = new Array();
                      array.push(data?.item);
                      nb[i].commentList = array;
                    }
                  }
                }
                return nb;
              });
            }
          }
        } else if (data?.item?.saveGubun === "REMOVE") {
          if (data?.item?.division === "QUESTION") {
            if (
              data?.item?.showYn === "Y" ||
              iam.memAuth == "ADMIN" ||
              data?.item?.regId == (iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx)
            ) {
              setTotalCount((o) => {
                return --o;
              });
            }
            const tmp = [];
            setQuestionList((o) => {
              const nb = [...o];
              for (let i in nb) {
                if (nb[i].idx != data?.item?.idx) {
                  tmp.push(nb[i]);
                }
              }
              return tmp;
            });
          } else if (data?.item?.division === "COMMENT") {

            // 서버에서 전송한 업데이트된 질문 데이터로 상태 업데이트
            
            if (updatedQuestion) {
              setQuestionList((o) => {
                const nb = [...o];
                for (let i in nb) {
                  if (nb[i].idx == updatedQuestion.idx) {
                    // 질문 정보 업데이트 (commentCnt 포함)
                    nb[i] = { ...nb[i], ...updatedQuestion };
                    
                    // 댓글 목록에서 삭제된 댓글 제거
                    if (nb[i]?.commentList) {
                      nb[i].commentList = nb[i].commentList.filter(
                        comment => comment.idx !== data?.item?.idx
                      );
                    }
                  }
                }
                return nb;
              });
            } else {
              // Fallback: 기존 로직
              var tmp = [];
              setQuestionList((o) => {
                const nb = [...o];
                for (let i in nb) {
                  if (nb[i].idx == data?.item?.tQuestionIdx) {
                    const nb2 = nb[i].commentList;
                    for (let j in nb2) {
                      if (nb2[j].idx != data?.item?.idx) {
                        tmp.push(nb2[j]);
                      }
                    }
                    nb[i].commentList = tmp;
                  }
                }
                return nb;
              });
            }
          }
        } else if (data?.item?.saveGubun === "UPDATE") {
          if (data?.item?.division === "QUESTION") {
            setQuestionList((o) => {
              let nb = [...o];
              if(nb?.filter((q) => q.idx == data?.item?.idx)?.length > 0){
                for (let i in nb) {
                  if (nb[i].idx == data?.item?.idx) {
                    data.item.commentList = nb[i].commentList;
                    nb[i] = data?.item;
                  }
                }
              }else{
                nb.push(data?.item);
                nb = nb.sort((a, b) => b.regDate - a.regDate);
              }
              return nb;
            });
          } else if (data?.item?.division === "COMMENT") {
            setQuestionList((o) => {
              const nb = [...o];
              for (let i in nb) {
                if (nb[i].idx == data?.item?.tQuestionIdx) {
                  const nb2 = nb[i].commentList;
                  for (let j in nb2) {
                    if (nb2[j].idx == data?.item?.idx) {
                      nb[i].commentList[j] = data?.item;
                    }
                  }
                }
              }
              return nb;
            });
          }
        } */
        
        $("body").scrollTop(y);
      });
  };

  const setShowCommentWriteBox = (q, showYn) => {
    setQuestionList((o) => {
      const nb = [...o];
      for (let i in nb) {
        if (nb[i].idx == q.idx) {
          nb[i].showCommentWriteBox = showYn;
        }
      }
      return nb;
    });
  };
  
  useEffect(() => {
    window.addEventListener("message", onReceivedMessage, myQuestion);
    return () => {
      window.removeEventListener("message", onReceivedMessage, myQuestion);
    };
  }, []);

  useEffect(() => {
    loadQuestionList();
  }, [moreView?.nextPage, myQuestion]);
  
  return (
    <Fragment>
      <div className="qna_container">
        <div className="question_write_box">
          <div className="question_write_box_inner">
            <h2>Q&#38;A</h2>
            <span>{questionContent.length}/500</span>
          </div>
          <div className="question_box_flex">
            <TextareaAutosize
              type="text"
              maxLength="500"
              placeholder="Please enter your question."
              value={questionContent}
              onChange={(e) => onSetQuestionContent(e)}
              style={{ overflow: "hidden" }}
            ></TextareaAutosize>
            <button
              type="button"
              id="button-addon22"
              onClick={(e) => questionSave()}
            >
              Submit
            </button>
          </div>
        </div>


        {/* <PerfectScrollbar useBothWheelAxes={false} suppressScrollX={true}> */}
        <div className="question_list_box">
          <div className="question_list_box_title" style={{marginBottom:`${iam?.memAuth == "ADMIN" ? "10px" : "20px"}`}}>
            <ul>
              <li className={cx({ on: myQuestion.onOff !== "Y" })}>
                <a className="all_question" onClick={(e) => myQuestionView(e, "N")}>
                  All questions
                </a>
              </li>
              <li className={cx({ on: myQuestion.onOff === "Y" })}>
                <a className="my_qustion" onClick={(e) => myQuestionView(e, "Y")}>
                  My questions
                </a>
              </li>
            </ul>
            <p><b>{totalCount}</b> question(s) registered.</p>
          </div>
          <div className={cx({ question_list_wrapper_box: true, admin_question_list_wrapper_box: iam?.memAuth == "ADMIN"})}>
            {!isEmpty(questionList) && questionList?.map((item, i) => (
              <Fragment key={item?.idx ?? i}>
                <Fragment>
                  {(myQuestion.onOff === "N" || (myQuestion.onOff === "Y" && item.regId == (iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx))) && (
                    <div
                      style={{display:`${iam.memAuth == "ADMIN" ? "block" : item.questionStatus == "REQUEST" || item.regId == (iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx) ? "block" : "none"}`}}
                      className={cx({
                        on: item.questionStatus === "WAIT" && iam.memAuth == "ADMIN",
                        question_list_inner_box: true,
                        active: toggleMenu[item.idx],
                      })}
                      id={`p_question_tab_${item.idx}`}
                    > 
                    <div className={cx({ question_list_box_desc: true})}>
                      <pre>{item.content}</pre>
                      <div className="question_list_box_date_reply">
                        <span className="question_list_box_date_reply_span">
                          {iam.memAuth == "ADMIN" ?(item?.name != null && item?.name != "" ? item?.name : item?.regId) + ' - ' : ""}{moment(item.regDate).format("MM.DD HH:mm:ss")}
                        </span>
                        <em>
                          <i className="demo-icon icon-comment" onClick={(e) => { showTogleReplyWrap(item) }}></i>
                        </em>
                          <div className="question_list_box_desc_btn" style={{ display: item.showCommentWriteBox == true ? "none": "flex",}}>
                            {iam.memAuth == "ADMIN" &&
                              <div className="qna_check_box">
                                <input
                                  type="checkbox"
                                  id={`switch${i}`}
                                  name="switch"
                                  className="input__on-off"
                                  value={item.questionStatus}
                                />
                                <label
                                  htmlFor={`switch${i}`}
                                  className="label__on-off label__on"
                                  style={{ backgroundColor: item?.questionStatus == "REQUEST" ? "#7758fa" : "#999999",}}
                                  onClick={(e) => questionSetShow(item)}
                                >
                                  <span
                                    className="marble"
                                    style={{ right: item?.questionStatus == "REQUEST" ? "3px" : "19px",}}
                                  ></span>
                                </label>
                              </div>
                            }
                            <button className="reply_btn" onClick={(e) => setShowCommentWriteBox(item, true)} >
                              <img src={replyImg} alt="Comment" />
                              <span>Comment</span>
                            </button>
                            {item?.commentList?.filter((c) => iam.memAuth == "ADMIN" || c.regId == (iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx) || c?.showYn === "Y")?.length > 0 && (
                              <button className="reply_count" onClick={(e) => setCommentListShowYn(i)} >
                                <img src={item?.commentListShowYn === "Y" ? replycountOnImg : replycountImg} alt="Number of comments" />
                                <small>{item?.commentListShowYn === "Y"? "Hide comment": "View comment"}</small>
                                <b style={{ fontWeight: "bold" }}>
                                  {item?.commentList?.filter((c) => iam.memAuth == "ADMIN" || c.regId == (iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx) || c?.showYn === "Y")?.length || 0}
                                </b>
                              </button>
                            )}
                           {(item.regId == (iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx) || iam.memAuth == "ADMIN") && (
                             <button className="reply_del_btn" onClick={(e) => removeQna("T_QUESTION", item)} >
                               <img src={replydelImg} alt="Delete" />
                               <span>{item?.preIdx ? "Retrieve Pre Question" : "Delete"}</span>
                             </button>
                           )}
                          </div>
                      </div>
                      <div className={cx({ comment_write_box: true, active: item?.showCommentWriteBox == true })} >
                        <div className="comment_write_box_top">
                          <h4><span>Comment</span></h4>
                          <p> {questionReplyContent[`answerContent-${item.idx}`]?.length || 0}/300 </p>
                        </div>
                        <div className="comment_write_box_flex" style={{ alignItems: "flex-end" }} >
                          <TextareaAutosize
                            type="text"
                            maxLength="300"
                            style={{ overflowY: "hidden" }}
                            placeholder="Write a comment."
                            aria-label="Write a comment."
                            aria-describedby="button-addon2"
                            value={ questionReplyContent[ `answerContent-${item.idx}` ] || "" }
                            onChange={(e) => changeReplyContent(item, e.target.value) }
                          />
                          <div className="comment_btn_box">
                            <button className="comment_btn_cancel" onClick={(e) => setShowCommentWriteBox(item, false)} >Cancle</button>
                            <button className="comment_btn_save" id="button-addon2" onClick={(e) => questionReply(item)} >Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                     {item?.commentListShowYn === "Y" && (
                       <Fragment>
                         {item?.commentList?.filter((c) => {
                           // 관리자는 모든 댓글 표시
                           if (iam.memAuth == "ADMIN") return true;
                           // 참가자: 본인 댓글 또는 공개된 댓글만 표시
                           const isMyComment = c.regId == iam.preregIdx;
                           const isPublicComment = c?.showYn === "Y";
                           return isMyComment || isPublicComment;
                         })?.map((comment, j) => (
                           <Fragment key={comment?.idx ?? `${item?.idx || 'comment'}-${j}`}>
                             <div
                               className={cx({
                                 comment_list_box: true,
                                 on:
                                   iam.memAuth == "ADMIN" &&
                                   comment.showYn === "N",
                                 active: toggleMenu[comment.idx],
                               })}
                             >
                               <img src={replystImg} alt="댓글" />
                               <div className="comment_list_box_inner">
                                 <pre>
                                   {/* <strong>Online Support : </strong> */}
                                   {comment.contents}
                                 </pre>

                                 <div className="question_list_box_date_reply">
                                   <span className="question_list_box_date_reply_span">
                                     {iam?.memAuth == 'ADMIN' ?  (comment?.name != null && comment?.name != "" ? comment?.name : "게스트") + ' - ' : ''}{moment(comment.regDate).format("MM.DD HH:mm:ss")}
                                   </span>
                                   <div className="question_list_box_desc_btn">
                                     {iam.memAuth == "ADMIN" && (
                                       <div className="qna_check_box">
                                         <input
                                           type="checkbox"
                                           id={`switch_q${i}_comment${j}`}
                                           name="switch"
                                           className="input__on-off"
                                           value={comment.showYn}
                                         />
                                         <label
                                           htmlFor={`switch_q${i}_comment${j}`}
                                           className="label__on-off label__on"
                                           style={{
                                             backgroundColor:
                                               comment?.showYn === "Y"
                                                 ? "#7758fa"
                                                 : "#999999",
                                           }}
                                           onClick={(e) =>
                                             questionCommentSetShow(
                                               comment
                                             )
                                           }
                                         >
                                           <span
                                             className="marble"
                                             style={{
                                               right:
                                                 comment?.showYn === "Y"
                                                   ? "3px"
                                                   : "19px",
                                             }}
                                           ></span>
                                         </label>
                                       </div>
                                     )}
                                     <button
                                       className="reply_del_btn"
                                       onClick={(e) =>
                                         removeQna(
                                           "T_QUESTION_COMMENT",
                                           comment
                                         )
                                       }
                                     >
                                       {(comment.regId == iam.preregIdx ||
                                         iam.memAuth == "ADMIN") && (
                                         <Fragment>
                                           <img
                                             src={replydelImg}
                                             alt="Delete"
                                           />
                                           <span>Delete</span>
                                         </Fragment>
                                       )}
                                     </button>
                                   </div>
                                 </div>
                               </div>
                             </div>
                           </Fragment>
                         ))}
                       </Fragment>
                     )}
                   </div>
                 )}
               </Fragment>
           </Fragment>
          ))}
          
            
        {(isEmpty(questionList) || questionList?.length <= 0) && (
          <div
            className="nonedata_box"
            style={{ textAlign: "center", padding: "20px 0" }}
          >
            <img
              src="https://cdn.onoffevent.com/common/icon_nonedata.svg"
              alt=""
              style={{ width: "70px" }}
            />
            <p style={{ fontSize: "13px", color: "#333333" }}>
              No questions.
            </p>
          </div>
        )}
      </div>
          {remainListCount > 0 && (
            <div className="detail_morebtn">
              <a onClick={(e) => onSetNextPage(e)}>More</a>
            </div>
          )}
        </div>
        {/* </PerfectScrollbar> */}
      </div>
    </Fragment>
  );
};

const CMessage = styled.div`
  margin-bottom: 0.5rem;
  span {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
`;
